import {
  LayoutDashboard,
  Store,
  Package,
  ShoppingCart,
  User,
  Users,
  Tag,
  BarChart3,
  Bell,
  Settings as SettingsIcon,
  Warehouse,
  Truck,
  Star,
  Sparkles,
  Map,
  Award,
  Banknote,
  Layers,
  Tablet,
  Target,
  Briefcase,
  Building2,
  CheckSquare,
  BookOpen,
  FileText,
  FileSignature,
  Activity,
  Receipt,
  ClipboardCheck,
} from 'lucide-react';
import { groupNavigation } from './groupNavigation.js';

export const SUPER_ADMIN_SECTION_DEFS = [
  { id: 'dashboard', title: 'Tableau de bord' },
  { id: 'platform', title: 'Plateforme' },
  { id: 'operations', title: 'Opérations' },
  { id: 'catalog', title: 'Catalogue' },
  { id: 'users', title: 'Utilisateurs' },
  { id: 'marketing', title: 'Marketing' },
  { id: 'gestion-nr2j', title: 'Gestion NR2J' },
  { id: 'configuration', title: 'Configuration' },
];

export const SUPER_ADMIN_SECTION_ITEM_ORDER = {
  dashboard: ['dashboard', 'analytics'],
  platform: ['commercants', 'carte', 'materiels', 'taxonomie', 'import-ia'],
  operations: ['commandes', 'caisse', 'caisse-kpi', 'livreurs'],
  catalog: ['produits', 'stocks'],
  users: ['clients', 'staff'],
  marketing: ['promotions', 'fidelite', 'avis-plateforme', 'communication'],
  'gestion-nr2j': [
    'nr2j-dashboard',
    'nr2j-clients',
    'nr2j-a-valider',
    'nr2j-taches',
    'prospection',
    'nr2j-mon-equipe',
    'nr2j-catalogue',
    'nr2j-devis',
    'nr2j-contrats',
    'nr2j-facturation',
    'nr2j-equipe',
    'nr2j-activite',
  ],
  configuration: ['parametres'],
};

/** Définitions items Super Admin — routes et libellés inchangés. */
export const SUPER_ADMIN_ITEMS_BY_ID = {
  dashboard: { id: 'dashboard', name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  analytics: { id: 'analytics', name: 'Analytics', href: '/analytics', icon: BarChart3 },
  commercants: { id: 'commercants', name: 'Commerçants', href: '/commercants', icon: Store },
  carte: { id: 'carte', name: 'Carte', href: '/carte-commercants', icon: Map },
  materiels: { id: 'materiels', name: 'Matériels', href: '/materiels', icon: Tablet },
  taxonomie: { id: 'taxonomie', name: 'Familles & métiers', href: '/taxonomie-commerce', icon: Layers },
  'import-ia': { id: 'import-ia', name: 'Import IA', href: '/import-ia', icon: Sparkles },
  commandes: { id: 'commandes', name: 'Commandes', href: '/commandes', icon: ShoppingCart },
  caisse: { id: 'caisse', name: 'Caisse (POS)', href: '/caisse', icon: Banknote },
  'caisse-kpi': { id: 'caisse-kpi', name: 'KPI Caisse', href: '/caisse/kpi', icon: BarChart3 },
  livreurs: { id: 'livreurs', name: 'Livreurs', href: '/livreurs', icon: Truck },
  produits: { id: 'produits', name: 'Produits', href: '/produits', icon: Package },
  stocks: { id: 'stocks', name: 'Ingrédients & ruptures', href: '/ingredients', icon: Warehouse },
  clients: { id: 'clients', name: 'Clients', href: '/clients', icon: User },
  staff: { id: 'staff', name: 'Staff', href: '/staff', icon: Users },
  promotions: { id: 'promotions', name: 'Promotions', href: '/promotions', icon: Tag },
  fidelite: { id: 'fidelite', name: 'Fidélité', href: '/fidelite', icon: Award },
  'avis-plateforme': { id: 'avis-plateforme', name: 'Avis Plateforme', href: '/avis-plateforme', icon: Star },
  communication: { id: 'communication', name: 'Communication', href: '/notifications', icon: Bell },
  'nr2j-dashboard': { id: 'nr2j-dashboard', name: 'Tableau de bord', href: '/nr2j', icon: Briefcase },
  prospection: { id: 'prospection', name: 'Prospection', href: '/prospection', icon: Target },
  'nr2j-clients': { id: 'nr2j-clients', name: 'Clients NR2J', href: '/nr2j/clients', icon: Building2 },
  'nr2j-catalogue': {
    id: 'nr2j-catalogue',
    name: 'Catalogue commercial',
    href: '/nr2j/catalogue',
    icon: BookOpen,
  },
  'nr2j-devis': { id: 'nr2j-devis', name: 'Devis', href: '/nr2j/devis', icon: FileText },
  'nr2j-contrats': {
    id: 'nr2j-contrats',
    name: 'Contrats',
    href: '/nr2j/contrats',
    icon: FileSignature,
  },
  'nr2j-facturation': {
    id: 'nr2j-facturation',
    name: 'Facturation',
    href: '/nr2j/facturation',
    icon: Receipt,
  },
  'nr2j-equipe': {
    id: 'nr2j-equipe',
    name: 'Équipe Clickorico',
    href: '/nr2j/equipe',
    icon: Users,
  },
  'nr2j-a-valider': {
    id: 'nr2j-a-valider',
    name: 'À valider',
    href: '/nr2j/a-valider',
    icon: ClipboardCheck,
  },
  'nr2j-mon-equipe': {
    id: 'nr2j-mon-equipe',
    name: 'Mon équipe',
    href: '/nr2j/mon-equipe',
    icon: Users,
  },
  'nr2j-activite': {
    id: 'nr2j-activite',
    name: 'Journal d’activité',
    href: '/nr2j/activite',
    icon: Activity,
  },
  'nr2j-taches': { id: 'nr2j-taches', name: 'Tâches', href: '/nr2j/taches', icon: CheckSquare },
  parametres: { id: 'parametres', name: 'Paramètres', href: '/settings', icon: SettingsIcon },
};

/** Liste plate legacy — ordre visuel des sections, routes inchangées. */
export const SUPER_ADMIN_NAV = SUPER_ADMIN_SECTION_DEFS.flatMap((section) =>
  (SUPER_ADMIN_SECTION_ITEM_ORDER[section.id] || [])
    .map((itemId) => SUPER_ADMIN_ITEMS_BY_ID[itemId])
    .filter(Boolean),
);

/** Super Admin : « Mon équipe » devient « Suivi commercial » (même route). */
const SUPER_ADMIN_NAV_ITEMS_FOR_SA = {
  ...SUPER_ADMIN_ITEMS_BY_ID,
  'nr2j-mon-equipe': { ...SUPER_ADMIN_ITEMS_BY_ID['nr2j-mon-equipe'], name: 'Suivi commercial' },
};

/**
 * Sections Super Admin — masque les sections vides (aucune condition métier Phase B).
 */
export function buildSuperAdminNavSections() {
  return groupNavigation(
    SUPER_ADMIN_SECTION_DEFS,
    SUPER_ADMIN_SECTION_ITEM_ORDER,
    SUPER_ADMIN_NAV_ITEMS_FOR_SA,
  );
}

/** Item de menu NR2J → permission minimale pour l'afficher. */
export const NR2J_NAV_PERMISSION = {
  'nr2j-dashboard': 'NR2J_DASHBOARD_VIEW',
  prospection: 'NR2J_PROSPECTS_VIEW',
  'nr2j-clients': 'NR2J_ORGANIZATIONS_VIEW',
  'nr2j-taches': 'NR2J_TASKS_VIEW',
  'nr2j-catalogue': 'NR2J_CATALOG_VIEW',
  'nr2j-devis': 'NR2J_QUOTES_VIEW',
  'nr2j-contrats': 'NR2J_CONTRACTS_VIEW',
  'nr2j-facturation': 'NR2J_INVOICES_VIEW',
  'nr2j-equipe': 'NR2J_USERS_MANAGE',
  'nr2j-activite': 'NR2J_ACTIVITY_ALL_VIEW',
};

/**
 * @param {string[]} permissions
 * @param {{ platformProfile?: string|null, role?: string|null }} [opts]
 */
export function buildNr2jStaffNavSections(permissions, opts = {}) {
  const allowed = new Set(permissions || []);
  const profile = opts.platformProfile || null;
  const role = opts.role || null;
  const canSeeMyTeam = role === 'SUPER_ADMIN' || profile === 'MANAGER_NR2J';
  const itemsById = role === 'SUPER_ADMIN' ? SUPER_ADMIN_NAV_ITEMS_FOR_SA : SUPER_ADMIN_ITEMS_BY_ID;
  const items = (SUPER_ADMIN_SECTION_ITEM_ORDER['gestion-nr2j'] || [])
    .map((itemId) => itemsById[itemId])
    .filter((item) => {
      if (!item) return false;
      if (item.id === 'nr2j-mon-equipe' || item.id === 'nr2j-a-valider') return canSeeMyTeam;
      const code = NR2J_NAV_PERMISSION[item.id];
      return code ? allowed.has(code) : false;
    });
  if (!items.length) return [];
  return [{ id: 'gestion-nr2j', title: 'Gestion NR2J', items }];
}

export function nr2jStaffHomePath(permissions) {
  const sections = buildNr2jStaffNavSections(permissions);
  return sections[0]?.items[0]?.href || '/nr2j';
}
